import React, { Component } from 'react';
import './ActionBar.css';

export class ActionBar extends Component {
  render() {
    const { onView, onReset, onInsert, onUpdate, sortOptions = [], onSortChange, selectedSort, hideInsertUpdate = false } = this.props;

    return (
      <div className="action-row">
        {!hideInsertUpdate && <button type="button" className="btn btn-outline" onClick={onInsert}>Insert</button>}
        {!hideInsertUpdate && <button type="button" className="btn btn-outline" onClick={onUpdate}>Update</button>}

        <select className="input-small" value={selectedSort || ''} onChange={(e) => onSortChange && onSortChange(e.target.value)}>
          <option value="">--- Sort On: ---</option>
          {sortOptions.map((option, index) => (
            <option key={index} value={option}>{option}</option>
          ))}
        </select>

        <select className="input-small">
          <option>Exact Match</option>
          <option>Wildcard</option>
        </select>

        <select className="input-small">
          <option>Any</option>
          <option>All</option>
        </select>

        <button type="button" className="btn btn-outline" onClick={onView}>View</button>
        <button type="button" className="btn btn-outline" onClick={onReset}>Reset</button>
      </div>
    );
  }
}

export default ActionBar;
